import React, { useEffect, useState } from 'react';
import './Orders.css';

function Orders() {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [pagination, setPagination] = useState({});

    const fetchOrders = async (pageNumber = 1) => {
        setLoading(true);
        try {
            const res = await fetch(`https://pentadeco.in/api/allorders?page=${pageNumber}&limit=20`);
            const data = await res.json();
            if (data.success) {
                setOrders(data.orders);
                setPagination(data.pagination);
            } else {
                console.log(data);
            }
        } catch (err) {
            console.log('Error fetching orders:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrders(page);
    }, [page]);

    const handleNext = () => {
        if (pagination.hasNextPage) setPage(pagination.nextPage);
    };

    const handlePrev = () => {
        if (pagination.hasPrevPage) setPage(pagination.prevPage);
    };

    // Function to change status via API
    const changeOrderStatus = async (orderid, newStatus) => {
        try {
            const res = await fetch(`https://pentadeco.in/api/orderstate/${orderid}/${newStatus}`);
            const data = await res.json();
            if (data.success) {
                setOrders((prevOrders) =>
                    prevOrders.map((order) =>
                        order.orderid === orderid ? { ...order, status: newStatus } : order
                    )
                );
            } else {
                alert(data.msg || 'Failed to update status');
            }
        } catch (err) {
            console.log('Error updating status:', err);
            alert('Error updating status');
        }
    };

    // Dynamic color classes for statuses
    const getStatusClass = (status) => {
        switch (status) {
            case 'pending':
                return 'text-warning border-warning bg-warning-subtle';
            case 'confirmed':
                return 'text-primary border-primary bg-primary-subtle';
            case 'packed':
                return 'text-info border-info bg-info-subtle';
            case 'dispatched':
                return 'text-secondary border-secondary bg-secondary-subtle';
            case 'delivered':
                return 'text-success border-success bg-success-subtle';
            case 'cancelled':
                return 'text-danger border-danger bg-danger-subtle';
            default:
                return 'text-dark border-dark bg-dark-subtle';
        }
    };

    return (
        <div className='main-orders'>
            <div className="container-fluid">
                <h2 className="body-font-bold fs-3 mb-4 mt-3">Orders</h2>

                {loading ? (
                    <p>Loading orders...</p>
                ) : (
                    <>
                        <div className="order-list mt-4 mb-5 px-2">
                            <div className="row p-2 bg-light fw-bold p-0">
                                <div className="col-md-2 border-end">DATE & TIME</div>
                                <div className="col-md-2 border-end">ORDER ID</div>
                                <div className="col-md-2 border-end">CUSTOMER</div>
                                <div className="col-md-3 border-end">PRODUCTS</div>
                                <div className="col-md-1 border-end">QTY/PRICE</div>
                                <div className="col-md-2 text-end">STATUS</div>
                            </div>

                            {orders?.map((order) => {
                                const totalQty = order.products.reduce((sum, p) => sum + p.quantity, 0);
                                const totalPrice = order.products.reduce((sum, p) => sum + (p.price * p.quantity), 0);

                                return (
                                    <div className="row p-2 border-bottom p-0" key={order.orderid}>
                                        <div className="col-md-2 fs-sm border-end">{new Date(order.orderdate).toLocaleString()}</div>
                                        <div className="col-md-2 fs-esm border-end">{order.orderid}</div>
                                        <div className="col-md-2 border-end">
                                            <div className='fs-sm'>{order.address?.name}</div>
                                            <div className='fs-sm'>{order.number}</div>
                                            <div className='fs-sm lh-sm mt-2'>{`${order.address.address}`}</div>
                                            <div className='fs-sm lh-sm'>City: {`${order.address.city || 'N/A'}`}</div>
                                        </div>
                                        <div className="col-md-3 fs-sm border-end">
                                            {order.products.map((p, idx) => (
                                                <div key={idx}>
                                                    {p.proname} (x{p.quantity}) - ₹{p.price}
                                                </div>
                                            ))}
                                        </div>
                                        <div className="col-md-1 fs-sm border-end">
                                            {totalQty} items <br /> ₹{totalPrice}
                                        </div>
                                        <div className="col-md-2 text-end">
                                            <select
                                                className={`form-select outline-none shadow-none rounded-brand-esm ${getStatusClass(order.status)}`}
                                                value={order.status}
                                                onChange={(e) => changeOrderStatus(order.orderid, e.target.value)}
                                            >
                                                <option value="pending">Pending</option>
                                                <option value="confirmed">Confirmed</option>
                                                <option value="packed">Packed</option>
                                                <option value="dispatched">Dispatched</option>
                                                <option value="delivered">Delivered</option>
                                                <option value="cancelled">Cancelled</option>
                                            </select>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {/* Pagination */}
                        <div className="d-flex justify-content-between mb-4">
                            <button className="btn btn-primary" onClick={handlePrev} disabled={!pagination?.hasPrevPage}>
                                Previous
                            </button>
                            <span>Page {pagination?.currentPage} of {pagination?.totalPages}</span>
                            <button className="btn btn-primary" onClick={handleNext} disabled={!pagination?.hasNextPage}>
                                Next
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default Orders;
